import createEntity from "../../common/entity/createEntity";

export const entity = createEntity({
  name: "project",
  type: "projects",
  getState: (state) => state.projects.projects,
});
